import React, { useState, useEffect, useRef } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../../config";
import { setSessionData } from "../../cache";

function StudentcorrectionXI() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("intermediateAdminToken");
  const schoolCodeRef = useRef(null);
  const rollNoRef = useRef(null);

  const reg1Ref = useRef(null);
  const reg3Ref = useRef(null);
  const reg4Ref = useRef(null);

  const [loading, setLoading] = useState(false);

  // ---------------- SEARCH STATES ----------------
  const [candidateId, setCandidateId] = useState("");
  const [schoolCode, setSchoolCode] = useState("");
  const [rollNo, setRollNo] = useState("");

  const [regPart1, setRegPart1] = useState("");
  const [regPart2, setRegPart2] = useState("");
  const [regPart3, setRegPart3] = useState("");
  const [regPart4, setRegPart4] = useState("");

  useEffect(() => {
    if (!token) {
      navigate("/intermediate-admin");
    }

    const fetchPageLoadData11 = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/PageloadRegistrationData_CL11`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const result = await response.json();

        if (result?.data) {
          const {
            blockList,
            casteList,
            districtList,
            divyangList,
            mediumList,
            religionList,
            stateList,
            coreSubjects,
            matri_BhasaSubjects,
            compulsorySubjects,
            additionaLl_Subjects,
            optionalSubjects,
            electiveSubjects,
            sessionList,
            noDataFoundSessionList,
          } = result.data;

          setSessionData("blockList", blockList);
          setSessionData("casteList", casteList);
          setSessionData("districtList", districtList);
          setSessionData("divyangList", divyangList);
          setSessionData("mediumList", mediumList);
          setSessionData("religionList", religionList);
          setSessionData("stateList", stateList);
          setSessionData("coreSubjects", coreSubjects);
          setSessionData("matri_BhasaSubjects", matri_BhasaSubjects);
          setSessionData("compulsory_Paper_2Subjects", compulsorySubjects);
          setSessionData("additional_Subjects", additionaLl_Subjects);
          setSessionData("optional_Paper_1_2Subjects", optionalSubjects);
          setSessionData("electivesubj", electiveSubjects);
          setSessionData("sessionlist", sessionList);
          setSessionData("noDataFoundSessionList", noDataFoundSessionList);
        }
      } catch (error) {
        console.error("Error in page load:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPageLoadData11();
  }, [token, navigate]);

  const handleCandidateChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setCandidateId(value);

    if (value) {
      setSchoolCode("");
      setRollNo("");
    }
  };

  const handleSchoolCodeChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 5);
    setSchoolCode(value);

    if (value) {
      setCandidateId("");
    }

    if (value.length === 5) {
      rollNoRef.current?.focus();
    }
  };

  const handleRollNoChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 5);
    setRollNo(value);
  };
  const handleRollKeyDown = (e) => {
    if (e.key === "Backspace" && rollNo.length === 0) {
      schoolCodeRef.current?.focus();
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();

    const registrationFilled = regPart1 || regPart2 || regPart3 || regPart4;
    const registrationComplete =
      regPart1.length === 5 &&
      regPart2 &&
      regPart3.length === 4 &&
      regPart4.length === 2;

    if (!candidateId && !schoolCode && !rollNo && !registrationFilled) {
      Swal.fire({
        icon: "warning",
        title:
          "Please Enter Candidate ID OR School Code & Roll No OR Registration No",
      });
      return;
    }

    if (candidateId) {
    } else if (schoolCode || rollNo) {
      if (!schoolCode) {
        Swal.fire({
          icon: "warning",
          title: "Please Enter School Code",
        });
        return;
      }

      if (!rollNo) {
        Swal.fire({
          icon: "warning",
          title: "Please Enter Roll No",
        });
        return;
      }

      if (schoolCode.length !== 5) {
        Swal.fire({
          icon: "warning",
          title: "School Code must be exactly 5 digits",
        });
        return;
      }

      if (rollNo.length !== 5) {
        Swal.fire({
          icon: "warning",
          title: "Roll No must be exactly 5 digits",
        });
        return;
      }
    } else if (registrationFilled) {
      if (!registrationComplete) {
        Swal.fire({
          icon: "warning",
          title:
            "Registration No must be 5 digit - 2 character - 4 digit - 2 digit",
        });
        return;
      }
    }

    setLoading(true);

    try {
      const registrationNo = registrationComplete
        ? `${regPart1}-${regPart2}-${regPart3}-${regPart4}`
        : "";

      const requestBody = candidateId
        ? {
            candidatE_ID: candidateId,
            schooL_CODE: null,
            rolL_NO: null,
            registratioN_NO: null,
          }
        : registrationNo
          ? {
              candidatE_ID: null,
              schooL_CODE: null,
              rolL_NO: null,
              registratioN_NO: registrationNo,
            }
          : {
              candidatE_ID: null,
              schooL_CODE: schoolCode,
              rolL_NO: rollNo,
              registratioN_NO: null,
            };

      const response = await fetch(
        `${config.API_BASE_URL}/AdminFetchDataStudentRegistrationCandidateID_CL11`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        },
      );

      const data = await response.json();

      if (response.ok && data?.data?.student_Data) {
        Swal.fire({
          icon: "success",
          title: "Student Found",
          timer: 1200,
          showConfirmButton: false,
        });

        navigate("/intermediate-demographic-details-update-page-xi", {
          state: { studentData: data.data.student_Data },
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Not Found",
          text: data.message || "No student found with the given details.",
        });
      }
    } catch (err) {
      console.error("API Error:", err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.message || "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRegPart1Change = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 5);
    setRegPart1(value);

    if (value) {
      setCandidateId("");
      setSchoolCode("");
      setRollNo("");
    }

    // Directly move to 3rd box after 5 digits
    if (value.length === 5) {
      reg3Ref.current.focus();
    }
  };

  const handleRegPart3Change = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    setRegPart3(value);

    if (value.length === 4) {
      reg4Ref.current.focus();
    }
  };

  const handleRegPart4Change = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 2);
    setRegPart4(value);
  };

  const handleReg3KeyDown = (e) => {
    if (e.key === "Backspace" && regPart3.length === 0) {
      reg1Ref.current.focus();
    }
  };

  const handleReg4KeyDown = (e) => {
    if (e.key === "Backspace" && regPart4.length === 0) {
      reg3Ref.current.focus();
    }
  };
  return (
    <>
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}

        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />

          <div className="main-panel">
            <div className="content-wrapper">
              {/* HEADER */}
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-university" />
                      Student Demographic Details Correction for Class XI
                    </h1>
                  </section>
                </div>
              </div>

              {/* SEARCH SECTION */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-end">
                      {/* Candidate ID */}
                      <div className="col-md-2">
                        <label>Candidate ID</label>
                        <input
                          type="text"
                          className="form-control form-control-xs mt-2"
                          value={candidateId}
                          onChange={handleCandidateChange}
                          disabled={schoolCode !== ""}
                          maxLength={15}
                        />
                      </div>
                      <div className="col-md-1 text-center">
                        <label className="mb-2">Or</label>
                      </div>
                      <div className="col-md-3">
                        <div className="row">
                          <div className="col-md-6">
                            <label>School Code </label>
                            <input
                              ref={schoolCodeRef}
                              type="text"
                              className="form-control form-control-xs mt-2"
                              value={schoolCode}
                              onChange={handleSchoolCodeChange}
                              disabled={candidateId !== ""}
                              maxLength={5}
                            />
                            {/* <span className="text-danger">(5 Digits)</span> */}
                          </div>
                          <div className="col-md-6">
                            <label>
                              Roll No{" "}
                              {/* <span className="text-danger">(5 Digits)</span> */}
                            </label>
                            <input
                              ref={rollNoRef}
                              type="text"
                              className="form-control form-control-xs mt-2"
                              value={rollNo}
                              onChange={handleRollNoChange}
                              onKeyDown={handleRollKeyDown}
                              disabled={!schoolCode || candidateId !== ""}
                              maxLength={5}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-1 text-center">
                        <label className="mb-2">Or</label>
                      </div>
                      <div className="col-md-5">
                        <label>
                          Registration No{" "}
                          <span className="text-danger">
                            (5 digit-2 character-4 digit-2 digit)
                          </span>
                        </label>

                        <div className="row">
                          <div className="col-md-3">
                            <input
                              ref={reg1Ref}
                              className="form-control form-control-xs mt-2"
                              value={regPart1}
                              onChange={handleRegPart1Change}
                              disabled={candidateId || schoolCode || rollNo}
                              maxLength={5}
                            />
                          </div>

                          <div className="col-md-3">
                            <select
                              id="regDropdown"
                              className="form-select form-control-xs mt-2"
                              value={regPart2}
                              onChange={(e) => {
                                setRegPart2(e.target.value);
                              }}
                              disabled={
                                !regPart1 || candidateId || schoolCode || rollNo
                              }
                            >
                              <option value="">Select</option>
                              <option value="RA">RA</option>
                              <option value="RS">RS</option>
                              <option value="RC">RC</option>
                              <option value="PA">PA</option>
                              <option value="PC">PC</option>
                            </select>
                          </div>

                          <div className="col-md-3">
                            <input
                              ref={reg3Ref}
                              className="form-control form-control-xs mt-2"
                              value={regPart3}
                              onChange={handleRegPart3Change}
                              onKeyDown={handleReg3KeyDown}
                              disabled={
                                !regPart2 ||
                                candidateId ||
                                schoolCode ||
                                rollNo ||
                                !regPart1
                              }
                              maxLength={4}
                            />
                          </div>

                          <div className="col-md-3">
                            <input
                              ref={reg4Ref}
                              className="form-control form-control-xs mt-2"
                              value={regPart4}
                              onChange={handleRegPart4Change}
                              onKeyDown={handleReg4KeyDown}
                              disabled={
                                !regPart3 || candidateId || schoolCode || rollNo
                              }
                              maxLength={2}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "end" }}>
                      <button
                        className="btn btn-success"
                        style={{ marginTop: "30px" }}
                        onClick={handleSearch}
                      >
                        <i className="fa fa-search"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentcorrectionXI;
